// extracted by mini-css-extract-plugin
module.exports = {"uiMain":"GridLayout_uiMain__2ZTol","uiMainInner":"GridLayout_uiMainInner__q9rYP","uiMainInnerWr":"GridLayout_uiMainInnerWr__2f29h"};